export const Teams = 'Teams';
export const FFR_TEAMS = 'https://api.dev.website.ffr.nextmap.io/wp-json/ffr/v1/equipes';
//export const MIN_EFFECTIF = 23;
export const MIN_EFFECTIF = 0;
